import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S8MixedMediaSection } from '../components/interactive-sections/S8MixedMedia';
import { backgroundGradientOptions, textColorOptionsLimited } from '../utils/builderColorOptions';
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from '../utils/builderSharedInputs';

Builder.registerComponent(S8MixedMediaSection, {
  name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S8MixedMedia,
  friendlyName: 'S8 Mixed Media',
  inputs: [
    {
      name: 'headlineText',
      type: 'string',
      required: true,
      defaultValue: 'Milan in the Media',
      friendlyName: 'Headline Text',
      helperText: 'Main headline text for the section',
    },
    {
      name: 'headlineColor',
      type: 'string',
      defaultValue: 'Blue',
      enum: textColorOptionsLimited,
      friendlyName: 'Headline Color',
      helperText: 'Color for the headline text',
    },
    {
      name: 'items',
      type: 'list',
      friendlyName: 'Mixed Media Items',
      helperText: 'Add mixed media items (advertorials and videos) for the section',
      onChange: (options) => {
        if (options.get('items').length < 6) {
          alert('minimum items are 6, add items to continue')
        }
      },
      subFields: [
        {
          name: 'date',
          type: 'string',
          friendlyName: 'Date',
          required: true,
          helperText: 'Date for this item (format: 2025-03-02)',
          defaultValue: '2025-03-02'
        },
        {
          name: 'src',
          type: 'file',
          friendlyName: 'Image',
          allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'svg'],
          required: false,
          helperText: 'Upload an image for advertorial content. Use either image OR video, not both.',
        },
        {
          name: 'videoSrc',
          type: 'file',
          friendlyName: 'Video',
          allowedFileTypes: ['mp4', 'webm', 'ogg', 'mov'],
          required: false,
          helperText: 'Upload a video for video content. Use either image OR video, not both.',
        },
        {
          name: 'imageAltText',
          type: 'string',
          friendlyName: 'Image Alt Text',
          required: true,
          helperText: 'Alt text for the image',
          defaultValue: 'Mixed media item image'
        },
        {
          name: 'linkText',
          type: 'string',
          friendlyName: 'Link Text',
          required: true,
          helperText: 'Text for the link/button',
          defaultValue: 'Read More'
        },
        {
          name: 'linkUrl',
          type: 'string',
          friendlyName: 'Link URL',
          required: true,
          helperText: 'URL where the link will direct to. For external sites, include the full URL with https:// (e.g., https://www.nytimes.com). For internal Milan pages, use relative paths (e.g., /process).',
          defaultValue: 'https://www.nytimes.com'
        },
        {
          name: 'linkColor',
          type: 'string',
          friendlyName: 'Link Color',
          enum: textColorOptionsLimited,
          defaultValue: 'Blue',
          helperText: 'Color for the link text'
        },
        {
          name: 'title',
          type: 'string',
          friendlyName: 'Title',
          required: true,
          helperText: 'Title text for this item',
          defaultValue: 'Mixed Media Item Title'
        },
        {
          name: 'titleColor',
          type: 'string',
          friendlyName: 'Title Color',
          enum: textColorOptionsLimited,
          defaultValue: 'Navy',
          helperText: 'Color for the title text'
        }
      ],
      defaultValue: [
        {
          date: '2025-02-14',
          src: '',
          videoSrc: 'https://cdn.builder.io/o/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F0e666ead6cb54e5cab4ed8932e922eb8?alt=media&token=053e22c9-90eb-4ea5-8411-f2d17a7fa7bf&apiKey=10266dac478d4c768f6b6fbe586ae30e',
          imageAltText: 'Mixed media item image',
          linkText: 'Placeholder 1234',
          linkUrl: 'https://www.nytimes.com',
          linkColor: 'Navy',
          title: 'Milan Hair Laser Removal',
          titleColor: 'Turquoise'
        },
        {
          date: '2025-04-22',
          src: '',
          videoSrc: 'https://cdn.builder.io/o/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Fc9b6b374009a4aa4bdbed1d74fb201da?alt=media&token=b5a8996b-3295-462f-b8f6-fae0b4f80a8c&apiKey=10266dac478d4c768f6b6fbe586ae30e',
          imageAltText: 'Mixed media item image',
          linkText: 'Great Day Colorado',
          linkUrl: 'https://www.nytimes.com',
          linkColor: 'Navy',
          title: 'Milan Hair Laser Removal',
          titleColor: 'Turquoise'
        },
        {
          date: '2025-01-08',
          src: '',
          videoSrc: 'https://cdn.builder.io/o/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F437609d5a6e747f08085f731d22dcd8c?alt=media&token=cfbf5cc4-0413-4766-a00b-e4f2ad0ca9fa&apiKey=10266dac478d4c768f6b6fbe586ae30e',
          imageAltText: 'Mixed media item image',
          linkText: 'Twin Cities Live',
          linkUrl: '/',
          linkColor: 'Navy',
          title: 'Milan Laser Hair Removal Minneapolis',
          titleColor: 'Turquoise'
        },
        {
          date: '2025-06-15',
          src: '',
          videoSrc: 'https://cdn.builder.io/o/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Feac6b3a201594d7a951a067d352e83a2%2Fcompressed?apiKey=c4151190bbd34d13951dc83c1e1d656a&token=eac6b3a201594d7a951a067d352e83a2&alt=media&optimized=true',
          imageAltText: 'Mixed media item image',
          linkText: 'WCCB Charlotte',
          linkUrl: 'https://www.nytimes.com',
          linkColor: 'Navy',
          title: 'Carolina Insight: Milan Laser Hair Removal',
          titleColor: 'Turquoise'
        },
        {
          date: '2025-03-30',
          src: '',
          videoSrc: 'https://cdn.builder.io/o/assets%2F10266dac478d4c768f6b6fbe586ae30e%2F778205495c864552b5bdf2e115cafe93%2Fcompressed?apiKey=c4151190bbd34d13951dc83c1e1d656a&token=778205495c864552b5bdf2e115cafe93&alt=media&optimized=true',
          imageAltText: 'Mixed media item image',
          linkText: 'My Carolina',
          linkUrl: 'https://www.nytimes.com',
          linkColor: 'Navy',
          title: 'Milan Laser Hair Removal Hendersonville',
          titleColor: 'Turquoise'
        },
        {
          date: '2025-05-11',
          src: '',
          videoSrc: 'https://cdn.builder.io/o/assets%2F10266dac478d4c768f6b6fbe586ae30e%2Ff01dcd458f844f8d931850d7383c8a86%2Fcompressed?apiKey=c4151190bbd34d13951dc83c1e1d656a&token=f01dcd458f844f8d931850d7383c8a86&alt=media&optimized=true',
          imageAltText: 'Mixed media item image',
          linkText: 'WBKO13',
          linkUrl: 'https://www.nytimes.com',
          linkColor: 'Navy',
          title: 'Milan Laser Hair Removal Hendersonville',
          titleColor: 'Turquoise'
        }
      ]
    },
    ...getBackgroundColorInput({
      defaultValue: 'White',
    }),
    ...getBackgroundGradientInput({
      backgroundGradientName: 'backgroundGradient',
      backgroundGradientList: backgroundGradientOptions,
    }),
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'svg'],
      friendlyName: 'Background Image',
      helperText: 'Upload a background image or provide an image URL (optional)',
    },
    ...getPaddingInputs({
      desktopTop: 'small',
      desktopBottom: 'small',
      mobileTop: 'small',
      mobileBottom: 'small',
    }),
  ],
});
